import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type popupState = {
  res_data: {};
  save_id: string;
  loadState: boolean;
  disp_sw: boolean;
};

const popupSlice = createSlice({
  name: "popupData",
  initialState: {
    res_data: {},
    save_id: "",
    loadState: false,
    disp_sw: true,
  },
  reducers: {
    setResData: {
      reducer: (state: popupState, action: PayloadAction<{ res_data: {} }>) => {
        state.res_data = action.payload.res_data;
      },
      prepare(payload: { res_data: {} }) {
        return { payload };
      },
    },

    setId: {
      reducer: (
        state: popupState,
        action: PayloadAction<{ popup_id: string }>
      ) => {
        state.save_id = action.payload.popup_id;
      },
      prepare(payload: { popup_id: string }) {
        return { payload };
      },
    },

    setDispSw: {
      reducer: (
        state: popupState,
        action: PayloadAction<{ disp_sw: boolean }>
      ) => {
        state.disp_sw = action.payload.disp_sw;
      },
      prepare(payload: { disp_sw: boolean }) {
        return { payload };
      },
    },

    setLoad: {
      reducer: (
        state: popupState,
        action: PayloadAction<{ loadState: boolean }>
      ) => {
        state.loadState = action.payload.loadState;
      },
      prepare(payload: { loadState: boolean }) {
        return { payload };
      },
    },
  },
});

export const { setResData, setId, setDispSw, setLoad } = popupSlice.actions;
export default popupSlice.reducer;
